<template>
  <v-app>
    <Loading v-show="loading" />
    <v-container v-show="!loading">
      <v-row dense>
        <v-col cols="12">
          <v-container>
            <v-row justify="space-between">
              <v-col cols="1">
                <v-btn icon @click="$router.go(-1)">
                  <v-icon color="blue">
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="11">
                <v-row justify="end">
                  <v-col cols="5" sm="3" md="3" lg="3" xl="3">
                    <v-dialog v-model="dialogcoursecheck" width="500">
                      <template v-slot:activator="{ on, attrs }">
                        <div class="text-right">
                          <v-btn v-if="examStatus.coursePass === 1 && isSurveysFinished" color="black" width="109.5" dark :to="`./Certification`">
                            修了証発行
                          </v-btn>
                          <v-btn v-else color="grey lighten-2" width="109.5" dark v-bind="attrs" v-on="on">
                            修了証発行
                          </v-btn>
                        </div>
                      </template>
                      <v-card>
                        <v-card-title class="text-h6">
                          修了証発行条件を満たしていません
                        </v-card-title>
                        <v-card-text>
                          <div v-if="!preSurveyFinished" style="text-align: left">
                            受講前アンケートが未回答です
                          </div>
                          <div v-if="!examStatus.coursePass" style="text-align: left">
                            全単元の確認テストに合格していません
                          </div>
                          <div v-if="!postSurveyFinished" style="text-align: left">
                            受講後アンケートが未回答です
                          </div>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn color="primary" text @click="dialogcoursecheck = false">
                            確認
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                  <v-col cols="5" sm="3" md="3" lg="3" xl="3">
                    <div class="text-right">
                      <v-dialog v-model="dialog" width="1000">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="black" width="109.5" dark v-bind="attrs" v-on="on">
                            講座概要
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            講座概要
                          </v-card-title>
                          <v-card-actions>
                            <v-btn color="primary" text @click="dialog = false">
                              閉じる
                            </v-btn>
                          </v-card-actions>
                          <v-row justify="center">
                            <v-col cols="11">
                              <v-subheader class="text-left text-xl-h4 text-lg-h4 text-md-h5 text-sm-h6">
                                {{ courseSyllabus.courseTitle }}
                              </v-subheader>
                              <v-divider />
                            </v-col>
                          </v-row>
                          <v-card-text style="margin: 1rem auto">
                            <v-container v-if="courseSyllabus.introductionVideo !== null" class="text-center">
                              <v-container v-if="$vuetify.breakpoint.width > 800">
                                <iframe width="640" height="360" :src="courseSyllabus.introductionVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
                              </v-container>
                              <v-container v-if="$vuetify.breakpoint.width <= 800 && $vuetify.breakpoint.width > 550" cols="10">
                                <iframe width="480" height="270" :src="courseSyllabus.introductionVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
                              </v-container>
                              <v-container v-if="$vuetify.breakpoint.width <= 550" cols="12">
                                <iframe width="256" height="144" :src="courseSyllabus.introductionVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
                              </v-container>
                            </v-container>
                            <v-container v-else>
                              <v-spacer />
                            </v-container>
                            <v-row>
                              <v-container>
                                <v-row justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 学習内容 </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.studyContents" />
                                </v-row>
                                <v-row justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 課題内容 </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.taskContent" />
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 修了条件 </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.completionRequirements" />
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 前提条件 </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.prerequisite" />
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 到達目標 </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.attainmentTarget" />
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 想定学習時間 </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.estimatedLearningTime" />
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 学習期間（スケジュール） </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.schedule" />
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 反転授業 </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <!-- -に固定 -->
                                  <v-col v-if="courseSyllabus.flippedClassroom" class="text-left" cols="9" style="white-space: pre-wrap" v-text="courseSyllabus.flippedClassroom" />
                                  <v-col v-else class="text-left" cols="9">
                                    -
                                  </v-col>
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 補助教材 </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col v-if="courseSyllabus.supplementaryTeachingMaterials" class="text-left" style="white-space: pre-wrap" cols="9" v-text="courseSyllabus.supplementaryTeachingMaterials" />
                                  <v-col v-else class="text-left" cols="9">
                                    -
                                  </v-col>
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 修了証 </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col v-if="courseSyllabus.certificateOfCompletion" class="text-left" cols="9">
                                    あり
                                  </v-col>
                                  <v-col v-else class="text-left" cols="9">
                                    なし
                                  </v-col>
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> バッジ </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col v-if="courseSyllabus.badge" class="text-left" cols="9">
                                    あり
                                  </v-col>
                                  <v-col v-else class="text-left" cols="9">
                                    なし
                                  </v-col>
                                </v-row>
                                <v-row align="center" justify="center">
                                  <v-col cols="10">
                                    <v-subheader> 講師・スタッフ </v-subheader>
                                    <v-divider />
                                  </v-col>
                                  <v-col class="text-left" cols="9">
                                    <v-row v-for="(instructor, index) in courseSyllabus.instructor" :key="index">
                                      <v-col>
                                        <div class="text-h7" style="white-space: pre-wrap" v-text="instructor" />
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="primary" text @click="dialog = false">
                              閉じる
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <v-container>
            <v-row>
              <v-col class="text-left text-caption grey-text">
                <div v-if="currentCourse !== null">
                  {{ currentCourse.courseName }}
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-list>
            <div v-for="(unit, index) in units" :key="index">
              <v-divider />
              <UnitListContent
                :unit="unit"
                :is-pre-survey-finished="preSurveyFinished"
                :is-post-survey-finished="postSurveyFinished"
                :qualify-list="examStatus.qualifyList"
              />
            </div>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios'
import store from '@/store/store'
import repository from '@/store/repository'
import handleApiError from '@/plugins/handleApiError'
import Loading from '@/components/common/Loading'
import UnitListContent from '@/components/pages/unitList/UnitListContent.vue'

export default {
  components: {
    Loading,
    UnitListContent
  },
  data () {
    return {
      loading: false,
      units: require(`@/assets/courseData/courseUnits/${this.$route.params.courseId}.json`),
      courseSyllabus: require(`@/assets/courseData/courseSyllabuses/${this.$route.params.courseId}.json`),
      currentCourse: null,
      dialog: false,
      examStatus: {
        coursePass: 0,
        qualifyList: []
      },
      coursePass: null,
      isSurveysFinished: false,
      preSurveyFinished: true,
      postSurveyFinished: true,
      dialogcoursecheck: false
    }
  },
  computed: {},
  async created () {
    const courseId = this.$route.params.courseId
    const courseData = require('@/assets/courseData/courseCards.json')
    this.currentUnit = this.units.find((unit) => unit.systemUnitNumber === parseInt(this.$route.params.unitId))
    this.currentCourse = courseData.find((course) => course.systemName === courseId)
  },
  mounted: async function () {
    this.loading = true
    await this.checkCompletionTest()
    await this.checkSurveysFinished()
    this.loading = false
  },
  methods: {
    async checkCompletionTest () {
      const reqUrl = process.env.VUE_APP_CHECK_COMPLETION_API_URL
      const reqBody = {
        checkType: 'course',
        pjmUserId: String(repository.getPjmUserId()),
        cognitoUsername: store.state.username,
        cognitoIdToken: repository.getIdToken(),
        courseId: String(this.currentCourse.courseId)
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)

      this.examStatus = res.data
    },
    checkSurveysFinished: async function () {
      const reqUrl = process.env.VUE_APP_CHECK_SURVEY_API_URL
      const reqBody = {
        pjmUserId: String(repository.getPjmUserId()),
        cognitoIdToken: repository.getIdToken(),
        cognitoUsername: store.state.username,
        courseId: String(this.currentCourse.courseId)
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      // 受講前アンケートを回答しているか確認
      reqBody.checkType = 'pre'
      const resPre = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      if (!resPre.data.checkResult || resPre.data.checkResult !== 1) {
        this.preSurveyFinished = false
      }

      // postSurvey講後アンケートを回答しているか確認
      reqBody.checkType = 'post'
      const resPost = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      if (!resPost.data.checkResult || resPost.data.checkResult !== 1) {
        this.postSurveyFinished = false
      }

      // 受講前・受講後ともに回答しているなら isSurveysFinished は true
      this.isSurveysFinished = this.preSurveyFinished && this.postSurveyFinished
    }
  }
}
</script>
<style scoped>
.wrap-text {
  word-break: break-all;
  white-space: normal;
}
</style>
